import { Link } from 'react-router-dom';
import { PASSENGER_SERVICES } from '../utils/homeData.js';
import { withBasePath } from '../utils/paths.js';

export default function PassengerServices() {
  return (
    <section className="py-16 sm:py-20" id="services">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="v4-reveal mb-10 flex flex-wrap items-end justify-between gap-4">
          <div className="max-w-2xl">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-nkc-gold">Passenger services</p>
            <h2 className="mt-2 font-display text-3xl font-bold text-nkc-navy sm:text-4xl">
              Support when you need it
            </h2>
          </div>
          <Link to="/services" className="text-sm font-bold text-nkc-blue hover:underline">
            All services →
          </Link>
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {PASSENGER_SERVICES.map((s) => (
            <article
              key={s.title}
              className="v4-reveal v4-zoom group overflow-hidden rounded-3xl bg-white shadow-soft ring-1 ring-nkc-blue/10"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img src={withBasePath(s.image)} alt="" className="h-full w-full object-cover" loading="lazy" />
              </div>
              <div className="p-6">
                <h3 className="font-display text-xl font-bold text-nkc-navy">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-nkc-muted">{s.description}</p>
                <Link to={s.to} className="mt-4 inline-flex text-sm font-bold text-nkc-blue group-hover:underline">
                  Learn more →
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
